import React from "react";
import styles from "./delivery-logs-filter.module.scss";
import { Autocomplete, Field, Filter, DateRange, Button } from "components/commons";
import { locale } from "localization/en";
import SearchTypeField from "components/commons/search-field/search-type";
import { productTypeOption } from "data/constant/delivery-log";
import { useRouter } from "hooks";
import { Path } from "enums";

const DeliveryLogsFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  resetFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
}) => {
  const router = useRouter();
  const dateType = [
    { label: locale.shiftDate, value: "shift" },
    { label: locale.deliveryDate, value: "delivery" },
  ];

  const searchType = [
    { label: locale.deliveryId, value: "deliveryId" },
    { label: locale.poReferenceNumber, value: "poReferenceNumber" },
    { label: locale.cashier, value: "cashier" },
    { label: locale.plateNumber, value: "plateNumber" },
  ];
  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Filter
          close={resetFilter}
          clear={applyClearFilter}
          submit={() => {
            applyFilter();
          }}
          filterCount={filterCount}
        >
          <Field
            label={locale.filterDateBy}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="dateType"
              value={filterState.dateType}
              options={dateType}
              onChange={(name, { value }) => {
                modifyFilter({ [name]: value });
              }}
              disableClearable
            />
          </Field>
          <Field
            className={styles.date}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.date}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({ startDate, endDate });
              }}
            />
          </Field>
          <Field
            label={locale.productType}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="productType"
              value={filterState.productType.value}
              options={productTypeOption}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({
                  [name]: {
                    value,
                    isSelectedAll,
                  },
                });
              }}
              multiple
              hasAll
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchTypeField
            placeholder={locale.keyword}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
            searchKeyName={"searchType"}
            searchKeyValue={filterState.searchType}
            searchKeyOptions={searchType}
            searchKeyOnChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
            disableClearable
          />
        </Field>
      </div>
      <Button
        onClick={() => router.push(Path.AddDeliveryLog)}
        primary
        className={styles.palePurpleButton}
      >
        {locale.addDeliverLog}
      </Button>
    </div>
  );
};

export default DeliveryLogsFilter;
